/**
 * Rich Nav - menus
 * @module richNav
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
import Keyboard from './keyboard';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'richNav';
export const GLOBAL_CLASS = '.js-global__nav';
export const MAIN_NAV = '#rich-nav-container';
export const SUB_NAV_MENU = '.sub-menu__wrapper';
export const DEPT_NAV_MENU = '.departments__wrapper';
export const CLICK_EVENT = 'click';
export const WOMENS_ENDPOINT_URL = '/r/ipadApp/MenuTree.jsp?deviceType=forwardmobile&loadAll=true&richNav=true';
export const MENS_ENDPOINT_URL = '/r/ipadApp/MenuTree.jsp?deviceType=forwardmobile&d=Mens&loadAll=true&richNav=true';
export const WOMENS_STORE_DATA_NAME = 'womens-data';
export const MENS_STORE_DATA_NAME = 'mens-data';
export const MAIN_MENU_ROOT_CATEGORY_NAME = 'main menu';
export const WOMENS_ROOT_CATEGORY_NAME = 'womens';
export const MENS_ROOT_CATEGORY_NAME = 'mens';
export const WOMENS_ROOT_SUBMENU = 'womens-menu__womens';
export const MENS_ROOT_SUBMENU = 'mens-menu__mens';
export const NEW_ROOT_CATEGORY_NAME = 'new';
export const MENS_PATHNAME = '/mens-';
export const MENS_DEPARTMENT_PARAM = 'd=Mens';
export const HP_PATHNAMES = ['/', '/fw/index.jsp', '/fw/mobile/indexWomen.jsp', '/fw/mobile/indexMen.jsp'];

const $body		           = $(document.body);
const $pageWrap          = $("#page-wrap");
const $headerWrapper     = $(".js-site-header__wrapper");
const $sideNav           = $("#js-nav-side");
const $overlay           = $(".js-nav-side__overlay");
const $burgerIcon        = $('#js-burger-icon');
const $richNavContainer  = $('#js-rich-nav');

export const DEFAULTS = {
  swapClass: '',
  swapTarget: '',
  rnItem: '.js-rich-nav',
  returnFocus: '',
  trapFocusFunc: Keyboard.trapFocus.bind(Keyboard),
  releaseFocusFunc: Keyboard.releaseFocus.bind(Keyboard),
};
/**
  * Set focus to first anchor in open side nav
  */
function openSideNavFocus(opts) {
  const $openSideNav = $('.is--open').last();
  if ($openSideNav.length > 0) {
    var $firstListItem = $openSideNav.children('.nav-side__list').first();
    // This could include more elements but should work for what we have (anchors or buttons and elements with tabindex not set to -1)
    $firstListItem.find('button, a, [tabindex]:not([tabindex="-1"])').eq(0).focus();
    opts.trapFocusFunc($openSideNav);
  } else {
    $('#rich-nav-title').focus(); // Focus on screen reader heading - Accessibility
    opts.trapFocusFunc($('.main-menu__wrapper'));
  }
}
/**
  * Open Rich Nav
  */
function openSideNav(opts) {
  $sideNav.show();
  $body.css({"overflow": "hidden"}).addClass('nav__sidebar--open');
  $richNavContainer.attr('aria-modal', 'true');

  // Set focus to the first element in the current sub nav
  openSideNavFocus(opts);

  let durationVal = 200;

  $sideNav.animate({
      left: "0"
  }, { duration: durationVal, queue: false });

  $pageWrap.animate({
      left: "270"
  }, { duration: durationVal, queue: false }).css({"position":"fixed"});

  $headerWrapper.animate({
      left: "270"
  }, { duration: durationVal, queue: false });

  $overlay.show().animate({
      left: "270",
      opacity: .8,
      display: 'block'
  }, { duration: durationVal, queue: false });

}
/**
  * Close Rich Nav
  */
function closeSideNav(opts) {
  $body.css({"overflow": "auto"}).removeClass('nav__sidebar--open');
  $richNavContainer.attr('aria-modal', 'false');

  let durationVal = 200;

  $sideNav.animate({
      left: "-270px"
  }, { duration: durationVal, queue: false });

  $pageWrap.css({"position":""}).animate({
      left: "0px"
  }, { duration: durationVal, queue: false });

  $headerWrapper.animate({
      left: "0px"
  }, { duration: durationVal, queue: false });

  $overlay.animate({
      left: "0",
      opacity: 0
  }, durationVal, function(){
      $overlay.hide();
  });

  opts.releaseFocusFunc($('.js-menu-wrapper'), '');
}
// Method to close all submenus
function removeAllSubMenus() {
  const elements = document.querySelectorAll('.sub-menu__wrapper');
  $(DEPT_NAV_MENU).removeClass('u-hide');
  elements.forEach(element => {
    element.classList.remove('is--open');
  });
}

// Method to set active tab
function setActiveTab() {
  const department = window.rcProps ? window.rcProps.department : '';
  $('.js-tabs-link').removeClass('tabs__link--active');
  $('.js-tabs-content').removeClass('tabs__content--active');
  if (department === 'Mens') {
    $('#mens-tab-button').addClass('tabs__link--active');
    $('#mens-menu__content').addClass('tabs__content--active');
  } else {
    $('#womens-tab-button').addClass('tabs__link--active');
    $('#womens-menu__content').addClass('tabs__content--active');
  }
}

/**
 * Create New Element
 * @param {Object} element - Elemnt used for generating New Element
 */
function createNode(element) {
  return document.createElement(element);
}
/**
 * Create New Element
 * @param {Object} parent - Parent element that items get appended to
 * @param {Object} el - Element that is appended to the parent
 */
function appender(parent, el) {
  return parent.appendChild(el);
}
/**
* Clone Element
* @param {Object} element - Element to clone
*/
function cloneElement(element) {
  return $(element).clone(true);
}
/**
* Remove Is Open Class
* @param {Object} element - Element to remove class from
* @param {Object} className - class to remove
*/
function removeIsOpen(element, className) {
  $(element).removeClass(className);
}
/**
* Error Handler
* @param {Object} response - response
*/
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}
/**
 * Toggle Class
 * @param {Object} options - Options used for wiring up the List
 */
function toggleMenuClass($el, $currentElement, wrapperHeight) {
  const dataSwapClass = $($currentElement).data('swapClass');
  const dataSwapTarget = $($currentElement).data('swapTarget');
  let $changingElClass = $($currentElement).attr('href');
  // If a data-swap-target attribute was used instead of href
  if (dataSwapTarget !== '') {
    $changingElClass = $(dataSwapTarget);
  }
  // Set Height of Sub Menu
  // console.log(wrapperHeight, lastWrapperHeight);
  // $changingElClass[0].style.minHeight = `${wrapperHeight}px`;
  $changingElClass.toggleClass(dataSwapClass);
  // if menu is hidden, make sure all next menus are hidden too
  // i.e. if you are in main menu->womens->beauty->bath & body->bath & shower, and you click on beauty back menu
  // then all menus after beauty (bath & body->bath & shower) are getting hidden too
  const $changingWrapperEl = $(dataSwapTarget); // menu div
  if(!$changingWrapperEl.hasClass(dataSwapClass)) {
    $($changingWrapperEl).nextAll().removeClass(dataSwapClass);
  }
}
/**
 * Scroll Element to Top
 * @param {Object} element - Element that is being checked
 */
function scrollToTop(element) {
  element.animate({ scrollTop: 0 }, 'fast');
}
/**
 * Build Wrapper Element - ie: div
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string} parentListDataId - string representing parent id attribute
 * @param {string[]} dataPath - the list of category names representing the path from the root to the target subcategory
 */
function buildWrapperElement(
  elem,
  dataElement,
  dataId,
  wrapperHeight,
  lastWrapperHeight,
  dataPath
) {
  const el = createNode(`${elem}`);
  const swapTargetClassName = buildForwardLinkSwapTargetClassName(dataId, dataPath, dataElement);
  const subMenuWrapperClass = 'sub-menu__wrapper';
  el.className = `${subMenuWrapperClass} js-menu-wrapper ${swapTargetClassName}`;
  el.dataset.element = `${dataElement}`;
  return el;
}
/**
 * Global elements to clone
 */
function cloneGLobalElements() {
  const globalNav = $(GLOBAL_CLASS);
  const globalNavClone = cloneElement(globalNav);

  return globalNavClone;
}
/**
 * Build List Element - ie: ul
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string} dataId - Data id of menu
 * @param {string} catName - Category name of menu
 * @param {Array} path - Path to the data subcategory
 */
function buildListElement(elem, dataElement, dataId, catName, parentPath) {
  const el = createNode(`${elem}`);
  el.className = 'nav-side__list sub-menu__list';
  // Set id to mens or womens - mens logic will be needed
  el.dataset.id = dataId;
  el.dataset.category = dataElement;
  const path = ((parentPath === undefined || parentPath.length == 0) ? [] : parentPath.slice());
  path.push(catName);
  el.dataset.path = JSON.stringify(path);
  return el;
}
/**
 * Build List Item Link - ie: li > a
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 */
function buildListItemElement(elem) {
  const el = createNode(`${elem}`);
  el.className = 'nav-side__item';
  return el;
}
/**
 * Build List Item Link - ie: li > a
 * @param {Object} elem - Element used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string[]} dataPath - the list of category names representing the path from the root to the target subcategory
 */
function buildListItemButtonElement(dataElement, dataId, dataName, htmlContent, dataPath) {
  const el = createNode('button');
  el.className = 'nav-side__link return-link js-rich-nav';
  el.dataset.swapClass = 'is--open';
  el.dataset.swapTarget = '.' + buildBackLinkSwapTargetClassName(dataId, dataPath, dataElement);
  el.dataset.element = dataElement;
  el.dataset.name = dataName;
  el.innerHTML = htmlContent;
  // Add screen reader text for back links to menus
  const backToText = window.rcProps.richNav.backToText;
  const backToSpan = createNode('span');
  backToSpan.className = 'u-screen-reader';
  backToSpan.innerHTML = backToText;
  el.prepend(backToSpan);
  return el;
}

/**
 * Get subCategories specified by path.
 * @param {Object} data left nav data
 * @param {Array} path the list of category names representing the path from the root to the target subcategory
 */
function findSubCategories(data, path) {
  let result = data;
  if (data && path && path.length > 0) {
    let tmpResult = data.filter(cat => cat.catName.toLowerCase() === path[0]);
    if(tmpResult && tmpResult.length > 0) {
      result = findSubCategories(tmpResult[0].subCategoryList, path.slice(1));
    }
  }
  return result;
}

function findSubTitle(data, path, title) {
  if(typeof title === 'undefined') {
    title = '';
  }
  let result = title;
  if (data && path && path.length > 0) {
    let tmpResult = data.filter(cat => cat.catName.toLowerCase() === path[0]);
    if(tmpResult && tmpResult.length > 0) {
      result = findSubTitle(tmpResult[0].subCategoryList, path.slice(1), tmpResult[0].nameDisplay);
    }
  }
  return result;
}

function createSubmenuTitle(ul, parentDisplayName, linkHref) {
  const subCategoryLink = buildListItemElement('li');
  let subCategoryListItem;
  if (linkHref) {
    subCategoryListItem = createNode('a');
    subCategoryListItem.href = linkHref;
  } else {
    subCategoryListItem = createNode('span');
  }
  subCategoryListItem.className = 'nav-side__link nav-side__link--no-link nav-side__link--main';
  subCategoryListItem.innerHTML = parentDisplayName;
  appender(subCategoryLink, subCategoryListItem);
  appender(ul, subCategoryLink);
}

function translateBackLinkNames(ul, data) {
  const backLinks = $(ul).find(".nav-side__link.return-link.js-rich-nav");
  if(backLinks && backLinks.length > 0) {
    const listDataPath = $(ul).data('path');
    if(listDataPath && listDataPath.length > 0) {
      backLinks.each((index, backLink) => {
        let linkDataName = $(backLink).data('name');
        const sliceIndex = listDataPath.findIndex((listDataName) => listDataName === linkDataName);
        if (sliceIndex >= 0) {
          const updatedBackName = findSubTitle(data, listDataPath.slice(0, sliceIndex+1));
          if(!!updatedBackName && updatedBackName!=='') {
            $(backLink).html(updatedBackName);
          } else if(linkDataName === NEW_ROOT_CATEGORY_NAME) {
            $(backLink).html(window.rcProps.richNav.dataNames.new);
          }
        } else {
          if (linkDataName === WOMENS_ROOT_CATEGORY_NAME) {
            $(backLink).html(window.rcProps.richNav.dataNames.womens);
          } else if (linkDataName === MENS_ROOT_CATEGORY_NAME) {
            $(backLink).html(window.rcProps.richNav.dataNames.mens);
          }
        }
      });
    }
  }
}

/**
 * Build List Items and Links - ie: li > a
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string[]} dataPath - the list of category names representing the path from the root to the target subcategory
 */
function buildListItems(data, ul, dataElement, dataId, dataCategory, dataLevel, dataPath) {
  let categories = {};
  let subCategories;
  let parentDisplayName;
  if (dataElement === 'new' || dataCategory === 'new') {
    categories = data.filter(cat => cat.catName.toLowerCase() === 'new arrivals');
    subCategories = categories[0].subCategoryList;
    parentDisplayName = categories[0].nameDisplay;
  } else if (dataElement === 'sale' || dataCategory === 'sale') {
    categories = data.filter(cat => cat.catName.toLowerCase() === 'sale');
    subCategories = categories[0].subCategoryList;
    parentDisplayName = categories[0].nameDisplay;
  } else {
    subCategories = findSubCategories(data, $(ul).data('path'));
    parentDisplayName = findSubTitle(data, $(ul).data('path'));
  }

  const addLeftMargin = window.rcProps && window.rcProps.richNav &&
        window.rcProps.richNav.categoriesForFeaturedDesigners &&
        window.rcProps.richNav.categoriesForFeaturedDesigners.indexOf(dataElement) >= 0;
  // create html markup for list items
  let links;
  // Go deeper if it's not New
  let subSubCats;
  if (dataElement !== 'new' && dataElement !== 'sale') {
    subSubCats = subCategories.filter(item => item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataElement);
    if(subSubCats && subSubCats.length > 0) {
      links = subSubCats[0].subCategoryList;
      parentDisplayName = subSubCats[0].nameDisplay;
    } else {
      links = subCategories;
    }
  } else {
    subSubCats = subCategories;
    if (dataElement === 'new') {
      // Get Arrival Dates subCategory List
      const arrivalSubCats = subSubCats[0].subCategoryList;
      // FIlter down to Category Names
      let arrivalLinksArray = arrivalSubCats.filter(item => item.catName);
      // Get Category Array from "new"
      const category = subSubCats[1];
      // Push category on to arrival dates links
      arrivalLinksArray.push(category);
      // Set links to Arrivals links array
      links = arrivalLinksArray;
    } else {
      links = subSubCats;
    }
  }

  if (dataElement === 'beauty' && window.rcProps.richNav.beautyLink) {
      createSubmenuTitle(ul, parentDisplayName, window.rcProps.richNav.beautyLink);
  } else {
      createSubmenuTitle(ul, parentDisplayName);
  }

  // update back menus display names
  translateBackLinkNames(ul, data);

  links.map((link) => {
    const categoryName = link.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
    const getParamValue = (s, paramName) => {
      const params = new URLSearchParams(s);
      return params.get(paramName);
    };
    // create list items for anchor tags
    const li = createNode('li');
    li.className = 'nav-side__item';
    // if (addLeftMargin) {
    //   li.className += ' u-margin-l--lg';
    // }
    if (link.headingTextOnly) {
      li.className += ' nav-side__item--hed';
      li.innerHTML = link.nameDisplay;
      appender(ul, li);
      return true;
    }
    // create anchor tags
    const a = createNode('a');
    const btn = createNode('button');
    if (link.subCategoryList === undefined || link.subCategoryList.length <= 1) {
      // create a anchor
      a.className = 'nav-side__link';
      a.href = link.href;
      a.innerHTML = link.nameDisplay.toLowerCase();
      appender(li, a);
      if (link.href && link.href.indexOf(window.location.pathname) !== -1) {
        if (window.location.href.indexOf(link.href) !== -1) {
          a.className = 'nav-side__link active';
        } else {
          a.className = 'nav-side__link';
        }
      }
    } else {
      // create a button
      btn.className = 'nav-side__link nav-side__link--category js-rich-nav';
      btn.dataset.swapClass = 'is--open';
      btn.dataset.swapTarget = '.' + buildForwardLinkSwapTargetClassName(dataId, dataPath, categoryName);
      btn.dataset.element = categoryName;
      btn.dataset.level = link.level;
      btn.innerHTML = link.nameDisplay.toLowerCase();
      appender(li, btn);
    }
    appender(ul, li);
    return true;
  });
}

function buildBackLinkSwapTargetClassName(start, middles, end) {
  var result = `${start}-menu__`;
  if(middles && middles.length > 0) {
    const middlesFixed = middles.map((middle) => {
      return middle.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
    });
    for (const middle of middlesFixed) {
      if( middle !== end) {
        result = `${result}${middle}__`;
      } else {
        break;
      }
    };
  }
  return `${result}${end}`;
}

function getDataEndpointVariables(isWomen) {
  return {
    endpointUrl : isWomen ? WOMENS_ENDPOINT_URL : MENS_ENDPOINT_URL,
    storeDataName : isWomen ? WOMENS_STORE_DATA_NAME : MENS_STORE_DATA_NAME
  };
}

function getRichNavData(isWomens, onDataLoad) {
  const dataEndpointVariables = getDataEndpointVariables(isWomens);
  const endpoint = dataEndpointVariables.endpointUrl;
  const storeData = dataEndpointVariables.storeDataName;

  if (sessionStorage.getItem(storeData)) {
    const data = JSON.parse(sessionStorage.getItem(storeData));
    onDataLoad(data);
  } else {
    fetch(endpoint, { credentials: 'same-origin' })
    .then(handleErrors)
    .then(response => response.json())
    .then((data) => {
      // set data in local storage
      sessionStorage.setItem(storeData, JSON.stringify(data));
      // Build List Items from data object
      onDataLoad(data);
    })
    .catch((error) => {
      console.log(error);
    });
  }
}

function buildForwardLinkSwapTargetClassName(start, middles, end) {
  var middle = ``;
  if(middles && middles.length > 0) {
    const middlesFixed = middles.map((element) => {
      return element.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
    });
    middle = middlesFixed.join('__') + '__';
  }
  return `${start}-menu__${middle}${end}`;
}

/**
 * Create New Navigation Menu
 * @param {Object} $currentElement - Elemnt used for generating New Menu
 */
function generateMarkup(
  $currentElement,
  dataElement,
  properDataElement,
  dataLevel,
  dataCategory,
  properDataCategory,
  $parentList,
  parentListDataId,
  parentWrapperElement,
  wrapperHeight,
  lastWrapperHeight,
  opts) {

  // get the list of dataElements representing the path from the root to the target subcategory
  const dataPath = $parentList.data('path');
  // create div wrapper for ul list and set height
  const div = buildWrapperElement(
    'div',
    dataElement,
    parentListDataId,
    wrapperHeight,
    lastWrapperHeight,
    dataPath
  );
  // create ul for list items with classes
  const ul = buildListElement('ul', dataElement, parentListDataId, properDataElement, dataPath);
  // Add ul to wrapping div
  appender(div, ul);
  // clone my account and customer care list
  if ($(GLOBAL_CLASS)[0]) {
    const globalNavigation = cloneGLobalElements();
    // Add My Account and Cutomer care after ul
    appender(div, globalNavigation[0]);
  }

  // create category back Link
  if (dataCategory !== '') {
    if (dataPath && dataPath.length > 0) {
      dataPath.forEach((pathElement, index) => {
        const categoryLink = buildListItemElement('li');
        const htmlContent = (index > 0) ? dataPath[index - 1] : parentListDataId;
        const categoryButton = buildListItemButtonElement(pathElement.replace(/[^A-Z0-9]/ig, '-').toLowerCase(), parentListDataId, htmlContent, htmlContent, dataPath);
        appender(categoryLink, categoryButton);
        appender(ul, categoryLink);
      });
      const categoryLink = buildListItemElement('li');
      const htmlContent = dataPath[dataPath.length - 1];
      const categoryButton = buildListItemButtonElement(dataElement, parentListDataId, htmlContent, htmlContent, dataPath);
      appender(categoryLink, categoryButton);
      appender(ul, categoryLink);
    } else {
      var dataName = window.rcProps.richNav.dataNames.womens;
      if (parentListDataId === MENS_ROOT_CATEGORY_NAME) {
        dataName = window.rcProps.richNav.dataNames.mens;
      }
      const categoryLink = buildListItemElement('li');
      const categoryButton = buildListItemButtonElement(dataElement, parentListDataId, properDataCategory, dataName, dataPath);
      appender(categoryLink, categoryButton);
      appender(ul, categoryLink);
    }
  }

  const forwardDataPath = ((dataPath === undefined || dataPath.length == 0) ? [] : dataPath.slice());
  forwardDataPath.push(properDataElement);

  getRichNavData(parentListDataId === WOMENS_ROOT_CATEGORY_NAME, function(data) {
    buildListItems(data, ul, dataElement, parentListDataId, dataCategory, dataLevel, forwardDataPath);
  });

  const closeButton = createNode('button');
  closeButton.className = 'js-rich-nav-close nav-side__item--close action-button action-button--full u-padding-a--md';
  closeButton.innerHTML = window.rcProps.richNav.closeMenuText;

  const closeBtnWrapper = createNode('div');
  closeBtnWrapper.className = 'u-padding-tb--md u-padding-rl--xl'

  appender(closeBtnWrapper, closeButton);
  appender(div, closeBtnWrapper)

  return div;
}

/**
 * Find the submenu containing the pathname.
 */
function findSubmenu(pathname, isWomens) {
  if($('.nav-side__link[href*="' + pathname + '"]').length > 1 && !isWomens) {
    return $('.nav-side__link[href*="' + pathname + '"][href*="' + MENS_DEPARTMENT_PARAM + '"]').closest('div')
  } else {
    return $('.nav-side__link[href*="' + pathname + '"]').closest('div');
  }
}

/**
 * Get the array containing the submenus ordered from the root to the $submenuElement.
 * Array elements are the data-swap-target classes.
 */
function recursiveSubmenuFinder($submenuElement, allSubmenus) {
  if(typeof allSubmenus === 'undefined') {
    allSubmenus = [];
  }
  const currentSubmenu = $submenuElement.attr('class').split(' ').find(clazz => clazz.endsWith('__' + $submenuElement.data('element')));
  if(currentSubmenu) {
    allSubmenus.unshift(currentSubmenu);
    const nextDataElement = currentSubmenu.slice(0, currentSubmenu.length-('__' + $submenuElement.data('element')).length);
    const $nextSubmenuElement = $('div[data-element="' + nextDataElement + '"]');
    if($nextSubmenuElement.length) {
      return recursiveSubmenuFinder($nextSubmenuElement, allSubmenus);
    }
  }
  return allSubmenus;
}

/**
 * Open submenus.
 */
function openAllSubmenus(allSubmenus) {
  allSubmenus.forEach((element) => {
    $(".nav-side__link--category[data-swap-target='." + element + "']").click();
  });
}

/**
 * Get the array containing category names of submenus ordered from root to the submenu containing the pathname.
 */
function recursiveCategoryNameFinder(pathname, categories, allCategoryNames) {
  if(categories && categories.length) {
    for(const category of categories) {
      if(!(category.subCategoryList && category.subCategoryList.length) && category.href && category.href.includes(pathname)
          && !(category.parentId == '-c-accessories--' && category.catName == 'Beauty')) {
        return allCategoryNames;
      } else {
        const updatedCategoryNames = allCategoryNames.slice();
        updatedCategoryNames.push(category.catName.toLowerCase());
        const resultCategoryNames = recursiveCategoryNameFinder(pathname, category.subCategoryList, updatedCategoryNames);
        if(resultCategoryNames.length > 0) {
          return resultCategoryNames;
        }
      }
    }
  }
  return [];
}

/**
 * Convert the array of submenu category names to the corresponding data-swap-target classnames.
 */
function getCategoryNameSubmenus(isWomens, categoryNames) {
  const categoryNameSubmenus = [];
  categoryNames.forEach((element, index) => {
    element = element.replace(/^new arrivals$/i, 'new');
    categoryNames[index] = element.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
  });
  for (let i = 1; i <= categoryNames.length-1; i++) {
    const categoryNameSubmenu = buildForwardLinkSwapTargetClassName(categoryNames[0], categoryNames.slice(1, i), categoryNames[i]);
    categoryNameSubmenus.push(categoryNameSubmenu);
  }
  categoryNameSubmenus.unshift(isWomens ? WOMENS_ROOT_SUBMENU : MENS_ROOT_SUBMENU);
  return categoryNameSubmenus;
}

/**
 * Sync the left nav with the current page.
 */
function goToSubmenu(pathname, querystring) {
  if(!HP_PATHNAMES.includes(pathname)) { // sync only the non-HP pathnames
    const isWomens = !(pathname.includes(MENS_PATHNAME) || querystring.includes(MENS_DEPARTMENT_PARAM));
    const $submenuDiv = findSubmenu(pathname, isWomens); // try to get existing submenu
    if($submenuDiv.length) {
      const allSubmenus = recursiveSubmenuFinder($submenuDiv);
      openAllSubmenus(allSubmenus); // sync left nav by opening all submenus from root to the closest one
    } else {
      getRichNavData(isWomens, function(data) {
        const categoryNames = recursiveCategoryNameFinder(pathname, data, []);
        if(categoryNames && categoryNames.length) {
          categoryNames.unshift(isWomens ? WOMENS_ROOT_CATEGORY_NAME : MENS_ROOT_CATEGORY_NAME);
          const categoryNameSubmenus = getCategoryNameSubmenus(isWomens, categoryNames);
          openAllSubmenus(categoryNameSubmenus); // sync left nav by opening all submenus from root to the closest one
        }
      });
    }
  }
}
/**
/**
 * Handles the click event when a Menu Item has been interacted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {Object} opts - Options passed along from initialization
 */
const itemClickHandler = (
  { currentTarget },
  $el,
  wrapperHeight,
  opts) => {
  // console.log(wrapperHeight);
  const $currentElement = $(currentTarget);
  // Get current parent ul div wrapper data element
  const parentWrapperElement = $currentElement.closest('.js-menu-wrapper')[0].dataset.element;
  // Get current parent ul
  const $parentList = $currentElement.parents('ul');
  // Get current parent ul category data attribute
  const dataCategory = $parentList[0].dataset.category;
  const properDataCategory = dataCategory.replace(/-{3}/ig, ' & ').replace(/-/ig, ' ');
  // Get current parent ul id data attribute
  const parentListDataId = $parentList[0].dataset.id;
  // generate the proper classes and data for menus
  const dataElement = $currentElement.attr('data-element').replace(/[^A-Z0-9]/ig, '-').toLowerCase();
  const properDataElement = dataElement.replace(/-{3}/ig, ' & ').replace(/-/ig, ' ');
  // Object Level value
  const dataLevel = $currentElement.attr('data-level');
  const swapTarget = $currentElement.data('swapTarget');
  const subMenu = $el.find(swapTarget);
  const PARENT_CLASS_PARAM = SUB_NAV_MENU;
  const lastWrapperHeight = $currentElement.parents(PARENT_CLASS_PARAM).outerHeight(true);
  //release trap focus
  opts.releaseFocusFunc($('.js-menu-wrapper'), $(opts.returnFocus));
  // Hide departments nav when sub menu is open
  $(DEPT_NAV_MENU).addClass('u-hide');
  // if clicking main menu
  if ($currentElement.attr('data-name') === MAIN_MENU_ROOT_CATEGORY_NAME) {
    removeIsOpen(SUB_NAV_MENU, 'is--open');
    // $(SUB_NAV_MENU).hide();
    openSideNavFocus(opts);
    // Show departments nav
    $(DEPT_NAV_MENU).removeClass('u-hide');
    return;
  }
  // if clicking womens
  if ($currentElement.attr('data-name') === WOMENS_ROOT_CATEGORY_NAME && dataCategory !== WOMENS_ROOT_CATEGORY_NAME) {
    $(SUB_NAV_MENU).not('.womens-menu__womens').removeClass('is--open');
    openSideNavFocus(opts);
    // Show departments nav
    $(DEPT_NAV_MENU).removeClass('u-hide');
    return;
  }
  // if clicking a nested mens link
  if ($currentElement.attr('data-name') === MENS_ROOT_CATEGORY_NAME && dataCategory !== MENS_ROOT_CATEGORY_NAME) {
    $(SUB_NAV_MENU).not('.mens-menu__mens').removeClass('is--open');
    openSideNavFocus(opts);
    // Show departments nav
    $(DEPT_NAV_MENU).removeClass('u-hide');
    return;
  }
  // if clicking main menu return link from loyalty program or Customer Care
  if ($currentElement.hasClass('return-link') && (dataElement === 'loyalty' || dataElement === 'customercare')) {
    $(DEPT_NAV_MENU).removeClass('u-hide');
  }
  // Conditional to check if menu is already built
  if (!subMenu.length) { // if subMenu does not exist build it - subMenuListId !== parentListDataId
    const newList = generateMarkup(
      $currentElement,
      dataElement,
      properDataElement,
      dataLevel,
      dataCategory,
      properDataCategory,
      $parentList,
      parentListDataId,
      parentWrapperElement,
      wrapperHeight,
      lastWrapperHeight,
      opts);
    $(MAIN_NAV).append(newList);
    // setTimeout allows for the slide in effect to occur
    setTimeout(() => {
      $(newList).addClass('is--open');
    }, 200);
    scrollToTop($el);
  } else {
    // Check if Existing Menu has global elements
    if (!subMenu.find(GLOBAL_CLASS).length) {
      if ($(GLOBAL_CLASS)[0]) { // check if any global menus exist
        // clone my account and customer care list
        const globalNavigation = cloneGLobalElements();
        appender(subMenu[0], globalNavigation[0]);
      }
      // Set Menu Height
      // console.log(wrapperHeight, lastWrapperHeight);
      // subMenu[0].style.minHeight = `${wrapperHeight}px`;
      // if (wrapperHeight < lastWrapperHeight) {
      //   subMenu[0].style.minHeight = `${lastWrapperHeight}px`;
      // }
    }
    toggleMenuClass(
      $el,
      $currentElement,
      wrapperHeight,
      lastWrapperHeight,
      opts);
    scrollToTop($el);
  }
  setTimeout(() => {
    // Get the last sub menu with the class of is--open
    openSideNavFocus(opts);
  }, 400);
};
/**
 * Applies any sort of event handlers for the richNav.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const applyEventHandlers = (
  $el,
  wrapperHeight,
  opts = {}) => {
  const { rnItem } = opts;
  let leftval;
  $el.on(CLICK_EVENT, rnItem, (evt) => {
    evt.preventDefault();
    itemClickHandler(
      evt,
      $el,
      wrapperHeight,
      opts);
  });
  // Open or Close Rich Nav
  $("#js-burger-icon, .js-nav-side__overlay").on(CLICK_EVENT, () => {
      leftval = $pageWrap.css('left');
      if(leftval == "0px") {
          openSideNav(opts);
      } else {
          closeSideNav(opts);
      }
  });
  // Close side nav with Keyboard - Accessibility
  $(document).on(CLICK_EVENT, '.js-rich-nav-close', (e) => {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }
    closeSideNav(opts);
    $burgerIcon.trigger('focus');
  });
  // Close Rich Nav with Escape Key
  $(document).on('keyup', (e) => {
    if (e.key === "Escape") { // escape key maps to keycode `27`
      leftval = $pageWrap.css('left');
      if (leftval !== "0px") {
        closeSideNav(opts);
        $burgerIcon.trigger('focus');
      }
    }
  });
  // close all sub menus when tabs are clicked
  $el.on(CLICK_EVENT, '.tabs__link', (e) => {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }
    removeAllSubMenus();
  });
};
/**
 * Initializes richNav.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function richNav(el, options = {}) {
  const $el = $(el);
  const mainWrapper = $(MAIN_NAV);
  const wrapperHeight = mainWrapper.outerHeight(true);
  const opts = mergeOptions(DEFAULTS, options, $el);
  applyEventHandlers(
    $el,
    wrapperHeight,
    opts);
  setActiveTab();
  goToSubmenu(location.pathname, location.search);
}
registerJQueryPlugin(PLUGIN_NAME, richNav);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/rich-nav.js